import { Button } from "primereact/button";
import React from "react";

const EmbedVideo = ({
  url,
  onCLick,
  onRemove,
  language_name,
  disableDelete = false,
  visibleDelete = true,
}) => {
  return (
    <div
      className="mr-3"
      style={{ display: "flex", flexDirection: "column", position: "relative" }}
    >
      <iframe
        width="175"
        height="100"
        src={url || ""}
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      ></iframe>
      <button type="button" className="btn btn-danger btn-xs mt-2">
        {language_name}
      </button>
      <button
        type="button"
        className="btn btn-warning btn-xs mt-2"
        onClick={onCLick}
      >
        Add Description
      </button>
      <Button
        style={{
          position: "absolute",
          top: -15,
          right: -15,
        }}
        type="button"
        className="p-button-rounded p-button-danger"
        icon="pi pi-times"
        onClick={onRemove}
        disabled={disableDelete}
        visible={visibleDelete}
      />
    </div>
  );
};

export default EmbedVideo;
